import { css } from '@lastbrand/web-ui-styled-system/css'
import { visuallyHidden } from '@lastbrand/web-ui-styled-system/patterns'

// A real `<input type="radio">` (needed for radiogroup keyboard a11y) hidden via the
// `visuallyHidden` pattern; it drives the `:checked`/`:focus` sibling styling on the label.
export const inputClass = visuallyHidden()

// Base label: `position: relative` so the OOS strikethrough `::before` overlay
// can be absolutely positioned over it (legacy `.label`).
export const labelClass = css({
  position: 'relative',
  cursor: 'pointer',
  // focus-visible ring driven by the sibling native radio (a11y requirement 5).
  'input:focus-visible + &': {
    outlineWidth: '2px',
    outlineOffset: '0.25rem',
    outlineStyle: 'solid',
    outlineColor: 'black',
    borderRadius: 'radius-outline',
  },
})

// Legacy `.label__leavingSoonOutOfStock`: muted text + a diagonal strikethrough
// drawn with a gradient `::before`. `#757575` (muted) → `mediumgray`; the legacy
// strikethrough line `#d3d2d2` → closest token `lightgray` (#D9D9D9, ~ΔE 12, near-identical light grey).
export const outOfStockClass = css({
  color: 'mediumgray',
  _before: {
    content: '""',
    display: 'block',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    // legacy strikethrough line `#d3d2d2` -> lightgray token (nearest)
    background:
      'linear-gradient(to top right, transparent calc(50% - 1px), token(colors.lightgray), transparent calc(50% + 1px))',
  },
})

// Legacy `.sr-only` span used for the swatch/image options' accessible label.
export const srOnlyClass = visuallyHidden()
